import React, { useState } from 'react';
import { get, isEmpty, remove } from 'lodash';
import { Card, Grid } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import { StyledDiv } from 'containers/ExpertExpertise/Dialogs/styles';
import Dialog from 'containers/AttributionManager/Dialogs/index';
import { CountPendingClaimsInboxeByManager } from 'containers/AttributionManager/utils';
import {
  StyleNameManager,
  StyledCardManager,
  StyledTitleButton,
  StyledIcon,
  StyledCheckCardManager,
  StyledTitleCheckedButton,
  StyledAddIcon,
} from 'containers/AttributionManager/styles';
import removeIcon from 'images/remove-icon.svg';

export interface AssignedManagerInboxesProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  validateDialog: Function;
  selectedManager: any;
  countInboxes: any;
  listings: any;
}

const AssignedManagerInboxesDialog: React.FC<AssignedManagerInboxesProps> = (
  props,
): JSX.Element => {
  const { onClose, open } = props;
  const [unassignedInboxes, setUnassignedInboxes] = useState([]);
  const isChecked = (id: never) => {
    return unassignedInboxes.includes(id);
  };
  const handleUnassignedInboxes = (el: any) => {
    let unassigned: any = [...unassignedInboxes];
    if (isChecked(get(el, 'inboxeId') as never)) {
      remove(unassigned, (item: any) => item === get(el, 'inboxeId'));
    } else {
      unassigned.push(get(el, 'inboxeId'));
    }
    setUnassignedInboxes(unassigned);
  };
  const handleValidate = () => {
    props.validateDialog({
      managerAssignementInboxes: [
        ...get(props.selectedManager, 'inboxes')
          .filter((el: any) => isChecked(el?.inboxeId as never))
          .map((item: any) => ({
            managerInboxesId: item?.managerInboxesId,
            userPrivilegesId: item?.userPrivilegesId,
          })),
      ],
    });
    props.onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      validateDialog={handleValidate}
      title={''}
      content={
        <StyledDiv>
          <span style={StyleNameManager}>
            {get(props.selectedManager, 'sagisName', '')}
          </span>
          {!isEmpty(get(props.selectedManager, 'inboxes', [])) &&
            get(props.selectedManager, 'inboxes', []).map((el: any) => (
              <Card
                style={
                  isChecked(get(el, 'inboxeId') as never)
                    ? StyledCheckCardManager
                    : StyledCardManager
                }
                elevation={0}
              >
                <Grid container direction="row" spacing={1}>
                  <Grid item>
                    <span
                      style={
                        isChecked(get(el, 'inboxeId') as never)
                          ? StyledTitleCheckedButton
                          : StyledTitleButton
                      }
                    >
                      {get(el, 'managerInboxe', '') +
                        ' (' +
                        CountPendingClaimsInboxeByManager(
                          get(props.listings, 'managerNotificationType', []),
                          get(props.selectedManager, 'name', ''),
                          props.countInboxes,
                          get(el, 'managerInboxesId'),
                        ) +
                        ')'}
                    </span>
                  </Grid>
                  <Grid item>
                    <img
                      src={removeIcon}
                      style={
                        isChecked(get(el, 'inboxeId') as never)
                          ? StyledAddIcon
                          : StyledIcon
                      }
                      data-testId={'icon-button'}
                      onClick={() => handleUnassignedInboxes(el)}
                      alt="remove icon"
                    />
                  </Grid>
                </Grid>
              </Card>
            ))}
        </StyledDiv>
      }
      disabled={false}
    />
  );
};

AssignedManagerInboxesDialog.defaultProps = {
  open: false,
};

export default injectIntl(AssignedManagerInboxesDialog);
